import React from 'react';
export function Solution() {
  return <section id="solucion" className="py-8 bg-orange-50" data-id="element-294">
      <div className="container mx-auto px-4" data-id="element-295">
        <div className="max-w-3xl mx-auto text-center mb-8" data-id="element-296">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-3" data-id="element-297">
            La Solución Real (y Probada)
          </h2>
          <p className="text-xl text-gray-600" data-id="element-298">
            Presentamos la Guía de Crianza Bilingüe: Un método claro, flexible y
            diseñado especialmente para familias hispanas en EE.UU.
          </p>
        </div>
        <div className="flex flex-col md:flex-row items-center gap-8" data-id="element-299">
          <div className="md:w-1/2" data-id="element-300">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/2mX5GStNAfV117eqAGBEXD/1-_Guia_de_Crianza_Bilingue_%28Mockup%29.png" alt="Guía de Crianza Bilingüe" className="w-full max-w-md mx-auto rounded-lg shadow-xl" data-id="element-301" />
          </div>
          <div className="md:w-1/2" data-id="element-302">
            <h3 className="text-2xl font-semibold text-orange-600 mb-5" data-id="element-303">
              En este ebook descubrirás:
            </h3>
            <ul className="space-y-3" data-id="element-304">
              <li className="flex" data-id="element-305">
                <svg className="h-6 w-6 text-green-500 mr-3 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-306">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" data-id="element-307" />
                </svg>
                <span data-id="element-308">
                  Estrategias específicas para bebés, niños y adolescentes
                </span>
              </li>
              <li className="flex" data-id="element-309">
                <svg className="h-6 w-6 text-green-500 mr-3 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-310">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" data-id="element-311" />
                </svg>
                <span data-id="element-312">
                  Métodos que funcionan: "un padre-un idioma", "casa vs.
                  escuela" y enfoques híbridos
                </span>
              </li>
              <li className="flex" data-id="element-313">
                <svg className="h-6 w-6 text-green-500 mr-3 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-314">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" data-id="element-315" />
                </svg>
                <span data-id="element-316">
                  Juegos, canciones, rutinas y apps que hacen que el español sea
                  divertido
                </span>
              </li>
              <li className="flex" data-id="element-317">
                <svg className="h-6 w-6 text-green-500 mr-3 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-318">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" data-id="element-319" />
                </svg>
                <span data-id="element-320">
                  Un plan paso a paso de 30 días para empezar esta misma semana
                </span>
              </li>
            </ul>
            <div className="mt-6" data-id="element-321">
              <p className="text-gray-700 mb-4" data-id="element-322">
                <span className="font-semibold" data-id="element-323">
                  Más de 5,000 familias hispanas
                </span>{' '}
                ya están viendo resultados con este método.
              </p>
              <div className="flex justify-center md:justify-start" data-id="element-324">
                <a href="#comprar" className="inline-block bg-orange-600 text-white px-6 py-3 rounded-md text-lg font-medium hover:bg-orange-700 transition-colors shadow-md" data-id="element-325">
                  Quiero esta guía para mi familia
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="mt-10 text-center" data-id="element-326">
          <div className="bg-orange-100 py-4 px-6 rounded-lg inline-block mb-8 max-w-2xl mx-auto" data-id="element-327">
            <h3 className="text-xl font-bold text-orange-700 mb-2" data-id="element-328">
              ¡OFERTA ESPECIAL POR TIEMPO LIMITADO!
            </h3>
            <p className="text-lg text-orange-800" data-id="element-329">
              Al adquirir la Guía de Crianza Bilingüe HOY, recibirás{' '}
              <span className="font-bold" data-id="element-330">COMPLETAMENTE GRATIS</span> estos 3
              ebooks exclusivos que potenciarán el aprendizaje de tus hijos.
            </p>
          </div>
        </div>
        <div className="grid md:grid-cols-3 gap-6" data-id="element-331">
          <div className="bg-white p-6 rounded-lg shadow-md relative overflow-hidden" data-id="element-332">
            {/* Diagonal "Hoy gratis" label */}
            <div className="absolute -right-10 top-5 bg-green-500 text-white py-1 px-10 transform rotate-45 shadow-md z-10" data-id="element-333">
              <span className="text-sm font-bold" data-id="element-334">Hoy gratis</span>
            </div>
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/4qmZVZAwrKefMrNQTry291/2-_Mini_Guia_Como_Manejar_las_Pantallas_sin_Perder_el_Espanol_%28Mockup%29.png" alt="Mini Guía: Cómo Manejar las Pantallas sin Perder el Español" className="w-full h-48 object-contain mb-4" data-id="element-335" />
            <h3 className="text-lg font-semibold text-orange-600 mb-2" data-id="element-336">
              <span className="font-bold" data-id="element-337">Bono 1:</span> Mini Guía: Cómo Manejar
              las Pantallas
            </h3>
            <p className="text-gray-600 mb-3" data-id="element-338">
              Estrategias prácticas para que las pantallas se conviertan en
              aliadas del bilingüismo.
            </p>
            <div className="text-right" data-id="element-339">
              <span className="text-gray-500 line-through mr-2" data-id="element-340">
                $19.99 USD
              </span>
              <span className="text-green-600 font-bold" data-id="element-341">¡Gratis!</span>
            </div>
          </div>
          <div className="bg-white p-6 rounded-lg shadow-md relative overflow-hidden" data-id="element-342">
            {/* Diagonal "Hoy gratis" label */}
            <div className="absolute -right-10 top-5 bg-green-500 text-white py-1 px-10 transform rotate-45 shadow-md z-10" data-id="element-343">
              <span className="text-sm font-bold" data-id="element-344">Hoy gratis</span>
            </div>
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/eYLKiWXmzFkRepskekEavB/3-_Recetas_y_Palabras_Cocina_con_tus_Hijos_en_Espanol_%28Mockup%29.png" alt="Recetas y Palabras: Cocina con tus Hijos en Español" className="w-full h-48 object-contain mb-4" data-id="element-345" />
            <h3 className="text-lg font-semibold text-orange-600 mb-2" data-id="element-346">
              <span className="font-bold" data-id="element-347">Bono 2:</span> Recetas y Palabras
            </h3>
            <p className="text-gray-600 mb-3" data-id="element-348">
              Recetas fáciles y rápidas acompañadas de vocabulario esencial en
              español e inglés.
            </p>
            <div className="text-right" data-id="element-349">
              <span className="text-gray-500 line-through mr-2" data-id="element-350">
                $14.99 USD
              </span>
              <span className="text-green-600 font-bold" data-id="element-351">¡Gratis!</span>
            </div>
          </div>
          <div className="bg-white p-6 rounded-lg shadow-md relative overflow-hidden" data-id="element-352">
            {/* Diagonal "Hoy gratis" label */}
            <div className="absolute -right-10 top-5 bg-green-500 text-white py-1 px-10 transform rotate-45 shadow-md z-10" data-id="element-353">
              <span className="text-sm font-bold" data-id="element-354">Hoy gratis</span>
            </div>
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/rbNvTvue8jVtDk6CSt32oQ/4-_Cuentos_Cortos_Bilingues_para_Dormir_Un_puente_entre_idiomas_y_corazones_%28Mockup%29.png" alt="Cuentos Cortos Bilingües para Dormir" className="w-full h-48 object-contain mb-4" data-id="element-355" />
            <h3 className="text-lg font-semibold text-orange-600 mb-2" data-id="element-356">
              <span className="font-bold" data-id="element-357">Bono 3:</span> Cuentos Cortos
              Bilingües
            </h3>
            <p className="text-gray-600 mb-3" data-id="element-358">
              Historias simples en español (con glosario en inglés) para lectura
              nocturna.
            </p>
            <div className="text-right" data-id="element-359">
              <span className="text-gray-500 line-through mr-2" data-id="element-360">
                $21.99 USD
              </span>
              <span className="text-green-600 font-bold" data-id="element-361">¡Gratis!</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}